import { createStore } from 'owa-satcheljs';
import type { ChatAnswer } from '../types';

export interface CopilotSearchAnswerStoreSchema {
    chatAnswer: ChatAnswer | undefined;
    isLoading: boolean;
    currentQuery: string | undefined;
}

const initialState: CopilotSearchAnswerStoreSchema = {
    chatAnswer: undefined,
    isLoading: false,
    currentQuery: undefined,
};

const store: () => CopilotSearchAnswerStoreSchema = createStore<CopilotSearchAnswerStoreSchema>(
    'copilotSearchAnswerStore',
    initialState
);

export default store;
export const getStore: () => CopilotSearchAnswerStoreSchema = store;
